import React from 'react'
import { safeLazy } from '../utils/SafeLazy/SafeLazy'
import ChunkLoader from '../components/ChunkLoader/ChunkLoader'

export const CAMPAIGN_MANAGER_PATH = '/campaign-manager'

const CampaignManagerPage = safeLazy(() => import('../pages/CampaignManager/CampaignManagerPage'))

export const CAMPAIGN_MANAGER_ROUTES = [
	{
		path: CAMPAIGN_MANAGER_PATH,
		element: (
			<ChunkLoader>
				<CampaignManagerPage />
			</ChunkLoader>
		),
	},
]
